import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
    name: 'sortBy',
    standalone: false
})
export class SortByPipe implements PipeTransform {

    transform(value: any[], order: string = '', column: string = ''): any[] {
        if (!value || order === '' || !order)
            return value;
        if (value.length <= 1)
            return value;
        if (!column || column === '') {
            if (order === 'asc')
                return value.sort();
            return value.sort().reverse();
        }
        // @ts-ignore - TODO: Refactor to align with "@types/lodash" typings - RYNO-12167
        return _.orderBy(value, [column], [order]);
    }
}
